
const DownloadIcon = () => {
    return (
        <svg width="19px" height="17px" viewBox="0 0 19 17" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PP---Desktop---Chat-Thread---Charts-and-Graphs---1920-Copy-2" transform="translate(-1648, -59)" stroke="#6C7275" strokeWidth="2">
                    <g id="Group-3" transform="translate(1649, 60)">
                        <path d="M16.484,11.1002 L16.484,12.5732 C16.484,13.7922 15.566,14.7092 14.347,14.7092 L2.137,14.7092 C0.917,14.7092 0,13.7922 0,12.5732 L0,11.1002" id="Stroke-1"></path>
                        <line x1="8.5475" y1="9.796" x2="8.5475" y2="0" id="Stroke-3"></line>
                        <polyline id="Stroke-5" points="12.6884 5.4114 8.5474 9.7964 4.4064 5.4114"></polyline>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default DownloadIcon;
